'use strict';


$(document).ready(function () {

    /**
     * Update DOM elements with Ajax results
     *
     * @param {Object} $results - jQuery DOM element
     * @param {string} selector - DOM element to look up in the $results
     * @return {undefined}
     */
    function updateDom($results, selector) {
        var $updates = $results.find(selector);
        $(selector).empty().html($updates.html());
        if ($updates.hasClass('refinements')) {
            let searchURL = $updates.find('.refinement .content .values button').data('href');
            history.replaceState('Search', document.title, decodeURIComponent(searchURL.replace('Ajax', '')));
        }
    }

    /**
     * Check if there are filters selected. If yes it will show the clear results button
     *
     */
    function validateClearResults() {
        var urlParams = new URLSearchParams(location.href);
        if ($('.filter__button--style.filter__button--active, .filter__box--style.filter__box--active, .color-attribute .selected').length > 0 ||
            $('.range-min').val() !== $('.range-min').attr('min') ||
            (urlParams.get('pmin') && urlParams.get('pmin') !== $('.range-min').attr('min')) ||
            $('.range-max').val() !== $('.range-max').attr('max') ||
            (urlParams.get('pmax') && urlParams.get('pmax') !== $('.range-min').attr('max'))) {
            $('.refinement-bar .secondary-bar').removeClass('d-none');
        } else {
            $('.refinement-bar .secondary-bar').addClass('d-none');
        }
    }

    /**
     * Keep refinement panes expanded/collapsed after Ajax refresh
     *
     * @param {Object} $results - jQuery DOM element
     * @return {undefined}
     */
    function handleRefinements($results) {
        $('.refinement.active').each(function () {
            $(this).removeClass('active');
            var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
            activeDiv.addClass('active');
            activeDiv.find('button.title').attr('aria-expanded', 'true');
        });

        updateDom($results, '.refinements');
    }
    /**
     * Parse Ajax results and updated select DOM elements
     *
     * @param {string} response - Ajax response HTML code
     * @return {undefined}
     */
    function parseResults(response) {
        var $results = $(response);
        var specialHandlers = {
            '.refinements': handleRefinements
        };

        // Update DOM elements that do not require special handling
        [
            '.grid-header',
            '.header-bar',
            '.header.page-title',
            '.product-grid',
            '.show-more',
            '.filter-bar',
            '.refinement-bar__show-button'
        ].forEach(function (selector) {
            updateDom($results, selector);
        });

        Object.keys(specialHandlers).forEach(function (selector) {
            specialHandlers[selector]($results);
        });
    }

    /**
     * Update param in url
     *
     * @return {string}
     */
    function replaceUrlParam(url, paramName, paramValue) {
        if (paramValue == null) {
            paramValue = '';
        }
        var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
        if (url.search(pattern) >= 0) {
            return url.replace(pattern, '$1' + paramValue + '$2');
        }
        url = url.replace(/[?#]$/, '');
        return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    }

    /**
     * Update Filter values after result appear
     *
     * @return {null}
     */
    function parseResultsCustomPrice(minV, maxV, maxPriceFilter) {
        $('.range-min').val(minV);
        $('.range-max').val(maxV);
        $('.input-min').val(minV);
        $('.input-max').val(maxV);
        $('.range-min').attr('max', maxPriceFilter);
        $('.range-max').attr('max', maxPriceFilter);
        $('.price-interval .price-interval-max').empty().text('$' + maxPriceFilter);
        $('.price-placeholder .price-placeholder-min span').empty().text('$' + minV);
        $('.price-placeholder .price-placeholder-max span').empty().text('$' + maxV);
        $('.price-placeholder .price-placeholder-min').css('left', ((minV / maxPriceFilter) * 100) + '%');
        $('.price-placeholder .price-placeholder-max').css('right', ((100 - ((maxV / maxPriceFilter) * 100))) + '%');
        $('.slider .progress').css('left', ((minV / maxPriceFilter) * 100) + '%');
        $('.slider .progress').css('right', (100 - ((maxV / maxPriceFilter) * 100)) + '%');
    }

    let priceGap = $('.price-gap').val() ? $('.price-gap').val() : 100;
    let priceFilterList = $('.filter__refinementulprice--style .filter__pricerefinementvalue--style span[aria-hidden="true"]').last();
    let maxValuePrice = 1000;

    if ($(priceFilterList).length > 0) {
        let priceFilterValues = $(priceFilterList).text().trim().split('-');

        if (priceFilterValues.length > 0) {
            maxValuePrice = parseInt(priceFilterValues[1].trim(), 10) + 1;
            $('.price-interval .price-interval-max').empty().text('$' + maxValuePrice);
            $('.range-max').attr('max', maxValuePrice);
            $('.range-min').attr('max', maxValuePrice);
            $('.input-max').val(maxValuePrice);
            $('.range-max').val(maxValuePrice);
            $('.price-placeholder .price-placeholder-max span').empty().text('$' + maxValuePrice);
        }
    }

    $(document).on('input', '.range-input input', function (e) {
        let minVal = parseInt($('.range-min').val(), 10),
            maxVal = parseInt($('.range-max').val(), 10);
        if ((maxVal - minVal) < priceGap) {
            if ($(this).hasClass('range-min')) {
                $('.range-min').val(maxVal - priceGap);
            } else {
                $('.range-max').val(maxVal + priceGap);
            }
        } else {
            $('.input-min').val(minVal);
            $('.input-max').val(maxVal);
            $('.price-placeholder .price-placeholder-min span').empty().text('$' + minVal);
            $('.price-placeholder .price-placeholder-max span').empty().text('$' + maxVal);
            $('.price-placeholder .price-placeholder-min').css('left', ((minVal / $('.range-max').attr('max')) * 100) + '%');
            $('.price-placeholder .price-placeholder-max').css('right', ((100 - (maxVal / $('.range-max').attr('max')) * 100)) + '%');
            $('.slider .progress').css('left', ((minVal / $('.range-min').attr('max')) * 100) + '%');
            $('.slider .progress').css('right', 100 - (maxVal / $('.range-max').attr('max')) * 100 + '%');
        }
    });

    $(document).on('input', '.price-input input', function (e) {
        let minPrice = parseInt($('.input-min').val(), 10),
            maxPrice = parseInt($('.input-max').val(), 10);

        if ((maxPrice - minPrice >= priceGap) && maxPrice <= $('.input-max').attr('max')) {
            if ($(this).hasClass('input-min')) {
                $('.range-min').val(minPrice);
                $('.slider .progress').css('left', ((minPrice / $('.range-max').attr('min')) * 100) + '%');
            } else {
                $('.range-max').val(maxPrice);
                $('.slider .progress').css('right', 100 - (maxPrice / $('.range-max').attr('max')) * 100 + '%');
            }
        }
    });

    $(document).on('change', '.range-input input', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let min = $('.range-min').val();
        let max = $('.range-max').val();
        let filterRoute = $('.filter__refinementulprice--style .filter__pricerefinementvalue--style button').first().data('href');
        filterRoute = replaceUrlParam(filterRoute, 'pmin', min);
        filterRoute = replaceUrlParam(filterRoute, 'pmax', max);

        $.spinner().start();
        $(this).trigger('search:filter', {
            currentTarget: {
                href: location.host + filterRoute
            }
        });

        $.ajax({
            url: filterRoute,
            data: {
                page: $('.grid-footer').data('page-number'),
                selectedUrl: filterRoute
            },
            method: 'GET',
            success: function (response) {
                parseResults(response);
                parseResultsCustomPrice(min, max, maxValuePrice);
                validateClearResults()
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
});